import { Suspense, useEffect, useState } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";
import { convertDateObjToServerStringFormat } from "@whoosh/utilities/src/dates";

import { BookingHistory, BookingHistoryQueryString } from "./BookingHistory";
import { BookingHistoryQuery } from "./__generated__/BookingHistoryQuery.graphql";

export const BookingHistoryQueryWrapper = () => {
  const [pageCursor, setPageCursor] = useState<string | null>(null);

  const [queryRef, loadQuery] = useQueryLoader<BookingHistoryQuery>(
    BookingHistoryQueryString
  );

  useEffect(() => {
    loadQuery(
      {
        dateGTE: convertDateObjToServerStringFormat(new Date()),
        first: 20,
        after: pageCursor,
      },
      { fetchPolicy: "store-and-network" }
    );
  }, [loadQuery, pageCursor]);

  return (
    <Suspense fallback={<Loader />}>
      {queryRef ? (
        <BookingHistory queryRef={queryRef} setPageCursor={setPageCursor} />
      ) : null}
    </Suspense>
  );
};
